import React from 'react'
import ModalComponent from '..'
import { ProductType } from '../../../redux-toolkits/products/products.type'
import Icon from '../../icon'

const options: {
  title: string
  value: ProductType
}[] = [
  {
    title: 'Single Product',
    value: 'single',
  },
  {
    title: 'Variant product',
    value: 'variant',
  },
  {
    title: 'Combo product',
    value: 'combo',
  },
  {
    title: 'Variant + combo product',
    value: 'variantCombo',
  },
  {
    title: 'Bundle',
    value: 'bundle',
  },
]

export const ChooseProductTypeModal: React.FC<{
  open: boolean
  setOpen: (cal: boolean) => void
  onCloseCallback?: () => void
  onSuccessCallback?: (productType: ProductType) => void
}> = ({
  open,
  setOpen,
  onCloseCallback = () => {},
  onSuccessCallback = () => {},
}) => {
  return (
    <ModalComponent
      open={open}
      setOpen={setOpen}
      onCloseCallback={() => {
        onCloseCallback()
      }}
      title={'What type of product would you like to create?'}
      childrenClassName="md:!max-w-[420px]"
    >
      <div className="flex flex-col items-center justify-center">
        {options.map((option) => {
          return (
            <button
              key={option.value}
              type="button"
              className="w-full flex items-center justify-between gap-4 py-4 first:pt-0 last:pb-0 border-b last:border-b-0 border-divider-gray text-base text-black"
              onClick={() => {
                onSuccessCallback(option.value)
              }}
            >
              {option.title}

              <Icon
                id="left-caret-new"
                width={24}
                height={24}
                className="rotate-180"
              />
            </button>
          )
        })}
      </div>
    </ModalComponent>
  )
}
